var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyPasswordIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 10.7498V14.2498C13.3332 17.1665 12.1665 18.3332 9.24984 18.3332H5.74984C2.83317 18.3332 1.6665 17.1665 1.6665 14.2498V10.7498C1.6665 7.83317 2.83317 6.6665 5.74984 6.6665H9.24984C12.1665 6.6665 13.3332 7.83317 13.3332 10.7498Z",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 5.74984V9.24984C18.3332 12.1665 17.1665 13.3332 14.2498 13.3332H13.3332V10.7498C13.3332 7.83317 12.1665 6.6665 9.24984 6.6665H6.6665V5.74984C6.6665 2.83317 7.83317 1.6665 10.7498 1.6665H14.2498C17.1665 1.6665 18.3332 2.83317 18.3332 5.74984Z",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPasswordIcon);
export default __webpack_public_path__ + "static/media/copy_password_icon.b6633ed03bcee860e3b9b63210b8794b.svg";
export { ForwardRef as ReactComponent };